import { render } from "./Logiplanner.vue?vue&type=template&id=445790c6&scoped=true"
import script from "./Logiplanner.vue?vue&type=script&lang=js"
export * from "./Logiplanner.vue?vue&type=script&lang=js"

import "./Logiplanner.vue?vue&type=style&index=0&id=445790c6&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445790c6"]])

export default __exports__